import { getResizedManagerImage } from "./GeneralTools"
import { getLocalItem } from "./StorageTools"

import headerBackground from "../assets/img/general/header-background.webp"

// Seleciona o banner configurado pela loja conforme a largura do viewport,
// redimensionado via CDN quando REACT_APP_CF_IMAGE_RESIZING estiver ativa
export const getBannerUrl = (settings = {}, width = window.innerWidth) => {
  let background = null
  let imageWidth = null

  if (width <= 600) {
    background = settings.site_banner_celular
    imageWidth = 828
  } else if (width <= 1280) {
    background = settings.site_banner_note
    imageWidth = 1366
  } else if (width <= 1920) {
    background = settings.site_banner_desktop
    imageWidth = 1920
  } else {
    background = settings.site_banner_tv
    imageWidth = 2560
  }

  return !!background ? getResizedManagerImage(background, imageWidth) : headerBackground
}

// Injeta um <link rel="preload"> do banner (LCP da home) antes do React montar,
// usando o settings persistido no localStorage em visitas anteriores.
// Na primeira visita (sem cache) não há o que precarregar.
export const preloadBannerImage = () => {
  try {
    const settings = getLocalItem("settings", true)
    if (!settings) return

    const link = document.createElement("link")
    link.rel = "preload"
    link.as = "image"
    link.fetchPriority = "high"
    link.href = getBannerUrl(settings)
    document.head.appendChild(link)
  } catch (error) {
    // storage indisponível ou settings corrompido — segue sem preload
  }
}
